import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

/**
 * Service partagé entre les composants affiché et main-ui pour faire le lien avec la sidebar ou la topbar
 */
@Injectable({
  providedIn: 'root'
})
export class MenuStoreService {
  private notificationNumberSource = new Subject<number>();
  public notificationNumberChange$ = this.notificationNumberSource.asObservable();

  emitNotificationNumber(data: number) {
    this.notificationNumberSource.next(data);
  }
}
